import React from 'react';
import GuestBook from './GuestBook';

const GuestBookPage = () => {
    return (
        <>
            <GuestBook />
            
            {/* Footer Section */}
            <footer className="app-footer">
                <p>Fatto con <span role="img" aria-label="heart">❤️</span> dagli sposi, Alessandro & Ylenia</p>
                <p>Copyright © {new Date().getFullYear()} - Preparatevi a festeggiare!</p>
            </footer>
        </>
    );
};

export default GuestBookPage; 
